/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M212.86 23.265c49.587 0 96.188 19.317 131.217 54.345 35.056 35.057 54.372 81.658 54.372 131.216 0 42.534-14.212 82.872-40.38 115.593a21.368 21.368 0 012.032 1.792l123.416 123.416c8.25 8.25 8.25 21.597 0 29.847-4.11 4.14-9.517 6.195-14.923 6.195-5.407 0-10.813-2.056-14.924-6.195L330.254 356.058a21.365 21.365 0 01-1.791-2.033c-32.723 26.174-73.064 40.39-115.602 40.39-49.558 0-96.16-19.317-131.188-54.373C46.617 305.013 27.3 258.412 27.3 208.826c0-49.558 19.317-96.16 54.373-131.216 35.029-35.028 81.63-54.345 131.188-54.345zm0 42.237c-38.266 0-74.28 14.896-101.34 41.984-27.087 27.06-41.983 63.045-41.983 101.34s14.896 74.309 41.984 101.368c27.06 27.06 63.073 41.984 101.34 41.984 38.295 0 74.308-14.924 101.368-41.984 27.088-27.06 41.984-63.073 41.984-101.368 0-38.295-14.896-74.28-41.984-101.34-27.06-27.088-63.073-41.984-101.368-41.984z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconSearch = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconSearch.defaultProps = {
  theme,
};
IconSearch.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconSearch.displayName = 'IconSearch';
export { IconSearch };
